import { useEffect } from 'react';

import { useCopyToClipboardContext } from 'Context/CopyToClipboardContext';

export const useCopyToClipboard = (triggerId, targetId) => {
    const { initializeClipboard } = useCopyToClipboardContext();

    useEffect(() => {
        if (triggerId && targetId) {
            initializeClipboard(triggerId, targetId);
        }
    }, [triggerId, targetId, initializeClipboard]);
};
